import AbstractModel from '../../api/models/AbstractModel';

export default class ChatRoleModel extends AbstractModel {
  static ROLES = Object.freeze({
    PARTICIPANT: 'chatParticipant',
    OWNER: 'chatOwner',
  });
}
